import { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import {
  CONCERT_INFO_BACKGROUND,
  MENU_BOARD1,
  MENU_BOARD2,
} from 'src/assets/database/webData';
import { popupNavigateState } from 'src/recoils/user-web.atom';
import { FlexBox, FlexBoxFullWidth } from 'src/styles/OverviewStyle';
import styled from 'styled-components';

export default function WebMenuBoard() {
  const [selectedMenu, setSelectedMenu] = useState('살거리');
  const [popupNavigate, setPopupNavigate] = useRecoilState(popupNavigateState);
  const onClickSelect = (event: React.MouseEvent<HTMLButtonElement>) => {
    const { value } = event.currentTarget;
    setSelectedMenu(value);
  };

  useEffect(() => {
    if (popupNavigate) {
      setPopupNavigate(false);
      setSelectedMenu('먹거리');
    }
  }, [popupNavigate]);
  return (
    <ContainerWebMenuBoard>
      <MenuSelectBlock>
        <h1>살거리﹒먹거리</h1>
        <h2>좋은 살거리와 맛있는 먹거리를 확인하세요.</h2>
        <ButtonBox>
          <SelectButton
            onClick={onClickSelect}
            value="살거리"
            selected={selectedMenu === '살거리'}
            type="button"
          >
            살거리
          </SelectButton>
          <SelectButton
            onClick={onClickSelect}
            value="먹거리"
            selected={selectedMenu === '먹거리'}
            type="button"
          >
            먹거리
          </SelectButton>
        </ButtonBox>
      </MenuSelectBlock>
      <MenuBackgroundImageBoard>
        {selectedMenu === '살거리' && <MenuImageBoard src={MENU_BOARD1} />}
        {selectedMenu === '먹거리' && <MenuImageBoard src={MENU_BOARD2} />}
      </MenuBackgroundImageBoard>
    </ContainerWebMenuBoard>
  );
}
const ContainerWebMenuBoard = styled(FlexBox)`
  width: 100%;

  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;
const MenuSelectBlock = styled(FlexBox)`
  width: 100%;
  padding: 40px 0 44px 0;

  background-color: #f0f1f4;

  flex-direction: column;
  justify-content: center;
  align-items: center;
  > h1 {
    color: var(--Font-02_black, #111);
    text-align: center;
    font-family: Cafe24Ohsquare;
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: -0.08px;
    margin-bottom: 4px;
  }
  > h2 {
    color: var(--Font-02_black, #111);
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 26px; /* 162.5% */
    letter-spacing: -0.04px;
    margin-bottom: 16px;
  }
`;
const ButtonBox = styled(FlexBox)`
  justify-content: center;
  align-items: center;
  gap: 12px;
`;
const SelectButton = styled.button<{ selected: boolean }>`
  background: #fff;
  padding: 8px 60px;
  border-radius: 24px;
  text-align: center;

  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
  letter-spacing: -0.04px;

  border: ${({ selected }) =>
    selected ? '1px solid #7BAF78' : '1px solid #E5E5EC'};
  color: ${({ selected }) => (selected ? '#206F1C' : '#505050')};

  display: flex;
  justify-content: center;
  align-items: center;
`;
const MenuBackgroundImageBoard = styled(FlexBoxFullWidth)`
  width: 101%;
  background-image: url(${CONCERT_INFO_BACKGROUND});
  background-size: cover;
  background-position: top;

  justify-content: center;
  align-items: center;
`;

const MenuImageBoard = styled.img`
  width: 1000px;
  margin: 0 auto;
`;
